/*
    author：liugy
    date：2019-5-5
*/
import base from 'lz-cloud-ui/src/env/develop'


export default base



// WEBPACK FOOTER //
// ./src/env/develop.js